export default function (value) {
  const isWhole = Number.isInteger(value);

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: isWhole ? 0 : 2,
        maximumFractionDigits: 2,
    }).format(value);
}
